import { gql } from '@grandvisionhq/graphql';
import { commercialCategoryFragment } from './fragments/small-fragments.js';
import './fragments/prices/productPriceItem.js';
import './fragments/prices/productPrice.js';
import './fragments/offerings.js';
import { productFragment } from './fragments/product.js';
import { variantFragment } from './fragments/variant.js';

const GET_ACCESSORIES_BY_SLUG = gql`
  query GetAccessoriesBySlug($slug: String!) {
    getProductBySlug(slug: $slug) {
      product {
        __typename
        ... on AccessoriesProduct {
          id
          ...productFragment
          commercialCategories {
            ...CommercialCategoryFragment
          }
          variants {
            ...variantFragment
            variantTypeDetails {
              channelAvailability
              recommendedCategoryKey
              brandModelCode
              brandModelColorCode
              targetGender
              targetGenderAllLocales {
                value
                locale
              }
              color
              colorAllLocales {
                locale
                value
              }
              material
              materialAllLocales {
                locale
                value
              }
              accessoryType {
                displayName
                displayNameAllLocales {
                  locale
                  value
                }
              }
            }
          }
        }
      }
    }
  }
  ${productFragment}
  ${commercialCategoryFragment}
  ${variantFragment}
`;

export { GET_ACCESSORIES_BY_SLUG };
//# sourceMappingURL=get-accessories-by-slug.js.map
